import React, { useEffect, useState } from "react";
import { NProgress } from "@tanem/react-nprogress";
import { Box } from "@chakra-ui/react";

const PageProgress = () => {
  const [isAnimating, setIsAnimating] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsAnimating(false);
    }, 800);

    return () => clearTimeout(timer);
  }, []);
  return (
    <NProgress isAnimating={isAnimating}>
      {({ isFinished, progress, animationDuration }) => (
        <div
          style={{
            opacity: isFinished ? 0 : 1,
            transition: `opacity ${animationDuration}ms linear`,
          }}
        >
          <Box
            bg="brand.500"
            h="2px"
            style={{
              left: 0,
              marginLeft: `${(-1 + progress) * 100}%`,
              position: "fixed",
              top: 0,
              transition: `margin-left ${animationDuration}ms linear`,
              width: "100%",
              zIndex: 1031,
            }}
          />
        </div>
      )}
    </NProgress>
  );
};

export default PageProgress;
